export function versionGreaterThanOrEqual(version: string, ...args): boolean {
  const supplierVersion = version.split('.');
  for (let i = 0; i < supplierVersion.length; i++) {
    const supplierVersionPart = parseInt(supplierVersion[i]);
    const requiredVersionPart = args[i] as number;
    if (supplierVersionPart < requiredVersionPart) return false;
    if (supplierVersionPart > requiredVersionPart) return true;
  }
  return true;
}
